var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchivedPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25833_194024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3.2C0 1.43269 1.43269 0 3.2 0H13.6L24 10.4V28.8C24 30.5673 22.5673 32 20.8 32H3.2C1.43269 32 0 30.5673 0 28.8V3.2Z",
    fill: "url(#paint0_linear_25833_194024)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10.4H24L13.6 0V8C13.6 9.32548 14.6745 10.4 16 10.4Z",
    fill: "#DCE2EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2002 0.400391H13.4346L23.5996 10.5654V28.7998C23.5996 30.3462 22.3462 31.5996 20.7998 31.5996H3.2002C1.6538 31.5996 0.400391 30.3462 0.400391 28.7998V3.2002C0.400391 1.6538 1.6538 0.400391 3.2002 0.400391Z",
    stroke: "black",
    strokeOpacity: 0.06,
    strokeWidth: 0.8
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.32909 27.4004V20.8549H6.91148C7.40793 20.8549 7.83087 20.9498 8.1803 21.1394C8.52973 21.3269 8.79607 21.5879 8.97931 21.9224C9.16468 22.2548 9.25736 22.6383 9.25736 23.073C9.25736 23.5076 9.16361 23.8912 8.97611 24.2235C8.78861 24.5559 8.51695 24.8148 8.16112 25.0002C7.80743 25.1855 7.37916 25.2782 6.87632 25.2782H5.23037V24.1692H6.6526C6.91894 24.1692 7.1384 24.1234 7.31098 24.0318C7.4857 23.938 7.61567 23.8091 7.7009 23.6451C7.78825 23.4789 7.83193 23.2882 7.83193 23.073C7.83193 22.8556 7.78825 22.666 7.7009 22.5041C7.61567 22.34 7.4857 22.2132 7.31098 22.1238C7.13627 22.0321 6.91467 21.9863 6.64621 21.9863H5.71297V27.4004H4.32909ZM12.2966 27.4004H9.97624V20.8549H12.3157C12.9741 20.8549 13.5409 20.986 14.016 21.248C14.4912 21.508 14.8566 21.8819 15.1122 22.3699C15.3701 22.8578 15.499 23.4416 15.499 24.1213C15.499 24.8031 15.3701 25.389 15.1122 25.8791C14.8566 26.3691 14.489 26.7452 14.0096 27.0073C13.5323 27.2694 12.9613 27.4004 12.2966 27.4004ZM11.3601 26.2147H12.239C12.6481 26.2147 12.9922 26.1422 13.2713 25.9973C13.5526 25.8503 13.7635 25.6234 13.9042 25.3166C14.0469 25.0076 14.1183 24.6092 14.1183 24.1213C14.1183 23.6376 14.0469 23.2424 13.9042 22.9355C13.7635 22.6287 13.5537 22.4029 13.2745 22.258C12.9954 22.1131 12.6513 22.0407 12.2422 22.0407H11.3601V26.2147ZM16.3441 27.4004V20.8549H20.6779V21.9959H17.728V23.5556H20.3903V24.6966H17.728V27.4004H16.3441Z",
    fill: "#344054"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25833_194024",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF1F7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25833_194024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchivedPdf);
export default __webpack_public_path__ + "static/media/archivedPdf.c57d7bc89e72ba045d1b4e533550b9ec.svg";
export { ForwardRef as ReactComponent };